import React, { Component } from 'react';
import Registry from "../../../Utils/Registry";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Label,
    Input,
    Col,
    Row,
    Alert
} from 'reactstrap';
import Vars from '../../../Utils/Variables';

import TYSelect from "../../TYSelect";
import {NotificationManager} from "react-notifications";

const { energies } = Vars;
const convertTable = { int: parseInt, float: parseFloat };

class OperationFleetUpdateItem extends Component {
    constructor(props){
        super(props);

        this.state = {
            model: this.props.vehicle.description,
            color: this.props.vehicle.color,
            plate: this.props.vehicle.plate,
            gas: this.props.vehicle.gas,
            gas_id: this.props.vehicle.gas_id,
            fleet_category: this.props.vehicle.category,
            energy_type: this.props.vehicle.energy_type,
            energy_sub_type: this.props.vehicle.energy_sub_type,
            fleet: "",
            errors: {
                model: false,
                plate: false,
                gas: false,
                color: false,
                fleet_category: false
            },
            loading: false,
            error_message: false,
        };

        this.api = Registry.registered("api");

        this.inputChanged = this.inputChanged.bind(this);
        this.updateVehicle = this.updateVehicle.bind(this);
    }

    inputChanged(e, input_key, convertType=undefined){
        if(this.state.hasOwnProperty(input_key)){
            let nState = this.state;

            let value = (typeof e === "string" ? e : e.target.value);
            if(convertType && convertTable[convertType])
                value = convertTable[convertType](value);

            nState[input_key] = value;
            nState.errors[input_key] = false;
            this.setState(nState);

            if (input_key == "gas_id")
                this.inputChanged(e, "gas");
        }
    }

    updateVehicle(){
        let valid = true;

        for (let k in this.state.errors) {
            if (this.state.errors.hasOwnProperty(k) && this.state[k] === "") {
                if(k !== "gas" || this.state.energy_type !== 1){
                    let nState = this.state;
                    nState.errors[k] = true;
                    this.setState(nState);
                    valid = false;
                }
            }
        }

        if(valid){
            this.setState({loading: true});
            const { vehicle } = this.props;
            this.api.put("/fleet/" + this.props.vehicle.id + "?type=business" , {
                description: vehicle.model !== this.state.model ? this.state.model : undefined,
                plate: vehicle.plate !== this.state.plate ? this.state.plate : undefined,
                color: vehicle.color !== this.state.color ? this.state.color : undefined,
                gas_id: vehicle.gas_id !== this.state.gas_id ? (this.state.energy_type === 0 ? this.state.gas_id : undefined) : undefined,
                category: vehicle.fleet_category !== this.state.fleet_category ? this.state.fleet_category : undefined,
                energy_type: vehicle.energy_type !== this.state.energy_type ? this.state.energy_type : undefined,
                energy_sub_type: vehicle.energy_sub_type !== this.state.energy_sub_type ? this.state.energy_sub_type : undefined
            })
                .then(result => {
                    this.setState({loading: false}, () => NotificationManager.success("Véhicule modifié !"));
                    this.props.toggle();
                    this.props.onVehicleUpdated();
                })
                .catch(error => {
                    this.setState({loading: false}, () => NotificationManager.error("Une erreur est survenue. Merci de bien vouloir réessayer"));
                })
        }
    }

    componentDidMount(){
        this.api.get("/fleet/categories?type=business")
            .then(result => {
                let categories = [];
                this.setState({fleet_categories: result.results});
                for (let cat of result.results)
                    categories.push(cat.category);
            });
    }

    render(){
        return (
            <Modal size="lg" isOpen={this.props.isOpen} toggle={this.props.toggle}>
                <ModalHeader toggle={this.props.toggle}>Modifier le vehicule</ModalHeader>
                <ModalBody>
                    <Row className="marg-b-10">
                        <Col xs="12" sm="6" className="marg-xs-b-10">
                            <Label for="car_model" className="bold" style={this.state.errors.model ? {color: "red"}:{}}>
                                Modele *
                            </Label>
                            <Input value={this.state.model} placeholder="Ex: Citroen C3" onChange={e => this.inputChanged(e, "model")} />
                        </Col>
                        <Col xs="12" sm="6" className="marg-xs-b-10">
                            <Label for="car_plate" className="bold" style={this.state.errors.plate ? {color: "red"}:{}}>
                                Plaque d'immatriculation *
                            </Label>
                            <Input value={this.state.plate} placeholder="TY-XXX-12" onChange={e => this.inputChanged(e, "plate")} />
                        </Col>
                    </Row>
                    <Row className="marg-b-10">
                        <Col xs="12" sm="6">
                            <Label for="gas_select" className="bold" style={this.state.errors.energy_type ? {color: "red"}:{}}>Type d'énérgie *</Label>
                            <Input type="select" name="select_energy_type" onChange={e => this.inputChanged(e, "energy_type", "int")} value={this.state.energy_type}>
                                <option value="">S&eacute;l&eacute;ctionner un type d'énérgie</option>
                                { energies.map(({ label, value }) => <option key={"energy-" + value} value={value}>{ label }</option>) }
                            </Input>
                        </Col>
                        
                        {
                            this.state.energy_type === 0 ?
                                <Col xs="12" sm="6">
                                    <Label for="gas_select" className="bold" style={this.state.errors.gas ? {color: "red"}:{}}>Carburant *</Label>
                                    <Input type="select" name="select_gas" onChange={e => this.inputChanged(e, "gas")}>
                                        <option value="">S&eacute;l&eacute;ctionner un carburant</option>
                                        { this.props.gas_list.map((gas, i) => <option key={"gas-" + i} value={gas.id}>{ gas.name }</option>) }
                                    </Input>
                                </Col>
                                :
                                <Col xs="12" sm="6">
                                    <Label for="gas_select" className="bold" style={this.state.errors.energy_sub_type ? {color: "red"}:{}}>Sous type *</Label>
                                    <Input type="select" name="select_energy_sub_type" onChange={e => this.inputChanged(e, "energy_sub_type", "int")} value={this.state.energy_sub_type}>
                                        <option value="">S&eacute;l&eacute;ctionner un sous type</option>
                                        { energies[this.state.energy_type].subTypes.map(({value, label}) => <option key={"subtype-" + value} value={value}>{ label }</option>) }
                                    </Input>
                                </Col>
                        }
                    </Row>
                    <Row className="marg-b-10">
                        <Col md="6">
                            <Label for="color_select" className="bold" style={this.state.errors.color ? {color: "red"}:{}}>
                                Couleur *
                            </Label>
                            <Input value={this.state.color} type="select" name="select_color" value={this.state.color} onChange={e => this.inputChanged(e, "color")}>
                                <option value="">S&eacute;l&eacute;ctionner une couleur</option>
                                <option value="Blanc">Blanc</option>
                                <option value="Noir">Noir</option>
                                <option value="Gris">Gris</option>
                                <option value="Jaune">Jaune</option>
                                <option value="Rouge">Rouge</option>
                                <option value="Bleu">Bleu</option>
                                <option value="Vert">Vert</option>
                                <option value="Orange">Orange</option>
                                <option value="Violet">Violet</option>
                            </Input>
                        </Col>
                        <Col md="6">
                            <Label for="fleet_select" className="bold" style={this.state.errors.fleet_category ? {color: "red"}:{}}>Flotte *</Label>
                            <TYSelect
                                items={this.props.categories}
                                selected={this.state.fleet_category}
                                otherActive={true}
                                itemClicked={item => {this.inputChanged(item, "fleet_category")}}
                                onOtherValueChanged={e => {this.inputChanged(e, "fleet_category")}}
                                otherPlaceholder="Ajouter une flotte ..."
                            />
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter className="center">
                    <Button className="text-uppercase" size="" color="secondary" onClick={this.props.toggle}>Annuler</Button>
                    {' '}
                    <Button className="text-uppercase" size="" color="primary" onClick={this.updateVehicle}>
                        {
                            this.state.loading ?
                                <i className="icon icon-loading animated spin infinite f-18"> </i>
                                : "Sauvegarder"
                        }
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }

}

OperationFleetUpdateItem.defaultProps = {
    onVehicleUpdated: () => {},
    vehicle: {},
    categories: [],
    toggle: () => {},
    isOpen: false,
    onClose: () => {},
    gas_list: []
};


export default OperationFleetUpdateItem;



// WEBPACK FOOTER //
// ./src/components/Operations/Fleet/UpdateItem.js